<template>
  <div class="sidebar-validasi themic --withbg">
    <div style="padding:10px; display:flex;" class="--header">
      <Select
        v-show="!searchMode"
        dbref="AST.SelJenis"
        :value.sync="jenisAsset"
        :valueAsObject="true"
        width="270px"
        style="margin-right:10px;"
        @change="UpdateValue"
      />
      <Input
        type="text"
        v-show="searchMode"
        :value.sync="keyword"
        placeholder="Cari .."
        width="280px !important"
      />
      <v-icon
        color="white"
        style="height: 27px; margin-left:10px; margin-top:5px;"
        v-show="!searchMode"
        @click="searchMode = !searchMode"
        >search</v-icon
      >
      <v-icon
        color="white"
        style="height: 27px; margin-left:10px; margin-top:5px;"
        v-show="searchMode"
        @click="searchMode = !searchMode"
        >clear</v-icon
      >
    </div>
    <div class="--body">
      <div style="font-size:14px; text-align:center" v-show="loading">
        <v-icon left>mdi-loading mdi-spin</v-icon>
        Loading ...
      </div>
      <List
        :items.sync="itemasset"
        :height="`calc(100vh - ${!tabs.length ? 160 : 200}px)`"
        @itemClick="AssetClicked"
        :selectOnLoad="true"
        v-show="!loading"
      >
        <template v-slot="{ row }">
          <div>
            <div style="color:black; font-weight:bold;">
              {{ row.NamaAsset }}
            </div>
            <div>{{ row.Alamat || row.NamaBalai }}</div>
          </div>
        </template>
      </List>
    </div>
    <v-btn
      text
      style="width:100%; margin-top:7px;"
      color="white"
      @click="AddAsset"
    >
      <v-icon>mdi-plus</v-icon>
      TAMBAH ASET
    </v-btn>
  </div>
</template>
<script>
export default {
  data: () => ({
    kabupaten: { val: null, txt: null },
    jenisAsset: 'jalan',
    selectedArea: {},
    searchMode: false,
    keyword: '',
    itemasset: [],
    tabId: 2,
    loading: false,
    pending: false,
    warnaDesa: ['palegreen', 'red', 'yellow', 'palegreen'],
    searchref: null,
  }),
  props: {
    value: Object,
    tahun: {
      type: [String, Number],
      default: () => {
        return new Date().getFullYear()
      },
    },
    tabs: {
      type: Array,
      default: () => [2, 12, 1, 9, 4],
    },
    rebind: Number,
  },
  watch: {
    rebind() {
      this.Populate()
    },
    value(val) {
      if (val.Tahun) this.proposal = { InputName: val.Tahun }
      if (val.Kabupaten) this.kabupaten = { txt: val.Kabupaten }
    },
    searchMode(val) {
      if (!val) this.keyword = ''
    },
    listParams(val) {
      if (!this.pending) {
        this.oldParams = JSON.stringify(val)
        this.$nextTick(() => {
          this.Populate()
        })
      }
    },
    tabId() {
      this.UpdateValue()
    },
  },
  created() {
    this.proposal = {
      InputName: this.tahun,
    }
    this.Populate()
  },
  computed: {
    listParams() {
      return {
        JenisAsset: this.jenisAsset.JenisId,
        Keyword: this.keyword,
      }
    },
  },
  methods: {
    async Populate() {
      clearTimeout(this.searchref)
      this.searchref = setTimeout(async () => {
        this.loading = true
        let res = await this.$api.call('AST.SelAssetList', this.listParams)
        if (res.data) {
          this.itemasset = res.data
        }
        this.loading = false
      }, 300)
    },
    AssetClicked(item) {
      if (!item || !item.AssetId) return
      this.pending = true
      setTimeout(() => {
        this.pending = false
      }, 500)

      this.$emit('update:value', item)
    },
    filterAsset(item) {
      return item.AreaName.match(new RegExp(this.keyword, 'i'))
    },
    UpdateValue() {
      // this.$emit('update:value', {
      //   tabId: this.tabId,
      //   Sumber: this.tabId,
      //   Tahun: this.proposal.InputName,
      //   ProposalID: this.proposal.ProposalID,
      //   Kabupaten: this.kabupaten.txt,
      // })
      // this.Populate()
    },
    AddAsset() {
      this.$emit('add-asset', {
        JenisAsset: this.jenisAsset.JenisId,
      })
    },
  },
}
</script>
<style lang="scss">
.sidebar-validasi {
  background: white;
  width: 350px;

  input {
    color: white;
    &::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: white;
      opacity: 1; /* Firefox */
    }
  }

  .ui-list {
    .--item {
      border-bottom: 1px solid #ddd;
      padding: 5px 8px;
      font-size: 12px;
      .ordr-1 {
        padding-left: 10px;
        display: flex;
        font-weight: bold;
        & > div {
          flex: 1;
        }
        .status {
          font-weight: normal;
          justify-content: flex-end;
          display: flex;

          .badge {
            padding-left: 9px;
            border-radius: 9px;
          }
        }
      }
      .ordr-2 {
        padding-left: 10px;
        display: flex;

        & > div {
          flex: 1;
        }
        .status {
          justify-content: flex-end;
          display: flex;

          .badge {
            padding-right: 9px;
            padding-left: 9px;
            border-radius: 9px;
          }

          .s-jml {
            background-color: #f3f3f3;
          }
        }
      }
    }
  }
}
</style>
